module.exports = function (THREE) {
  return function () {
    const v12599 = new THREE.Vector3();
    const v12600 = new THREE.Vector3();
    const v12601 = new THREE.Vector3();
    class Capsule {
      constructor(p15600 = new THREE.Vector3(0, 0, 0), p15601 = new THREE.Vector3(0, 1, 0), p15602 = 1) {
        this.start = p15600;
        this.end = p15601;
        this.radius = p15602;
      }
      clone() {
        return new Capsule(this.start.clone(), this.end.clone(), this.radius);
      }
      set(p15603, p15604, p15605) {
        this.start.copy(p15603);
        this.end.copy(p15604);
        this.radius = p15605;
      }
      copy(p15606) {
        this.start.copy(p15606.start);
        this.end.copy(p15606.end);
        this.radius = p15606.radius;
      }
      getCenter(p15607) {
        return p15607.copy(this.end).add(this.start).multiplyScalar(0.5);
      }
      translate(p15608) {
        this.start.add(p15608);
        this.end.add(p15608);
      }
      checkAABBAxis(p15609, p15610, p15611, p15612, p15613, p15614, p15615, p15616, p15617) {
        return (p15613 - p15609 < p15617 || p15613 - p15611 < p15617) && (p15609 - p15614 < p15617 || p15611 - p15614 < p15617) && (p15615 - p15610 < p15617 || p15615 - p15612 < p15617) && (p15610 - p15616 < p15617 || p15612 - p15616 < p15617);
      }
      intersectsBox(p15618) {
        return this.checkAABBAxis(this.start.x, this.start.y, this.end.x, this.end.y, p15618.min.x, p15618.max.x, p15618.min.y, p15618.max.y, this.radius) && this.checkAABBAxis(this.start.x, this.start.z, this.end.x, this.end.z, p15618.min.x, p15618.max.x, p15618.min.z, p15618.max.z, this.radius) && this.checkAABBAxis(this.start.y, this.start.z, this.end.y, this.end.z, p15618.min.y, p15618.max.y, p15618.min.z, p15618.max.z, this.radius);
      }
      lineLineMinimumPoints(p15619, p15620) {
        const v12602 = v12599.copy(p15619.end).sub(p15619.start);
        const v12603 = v12600.copy(p15620.end).sub(p15620.start);
        const v12604 = v12601.copy(p15620.start).sub(p15619.start);
        const v12605 = v12602.dot(v12603);
        const v12606 = v12602.dot(v12602);
        const v12607 = v12603.dot(v12603);
        const v12608 = v12603.dot(v12604);
        const v12609 = v12602.dot(v12604);
        let v12610;
        let v12611;
        const v12612 = v12606 * v12607 - v12605 * v12605;
        if (Math.abs(v12612) < 1e-10) {
          const v12613 = -v12608 / v12607;
          const v12614 = (v12605 - v12608) / v12607;
          if (Math.abs(v12613 - 0.5) < Math.abs(v12614 - 0.5)) {
            v12610 = 0;
            v12611 = v12613;
          } else {
            v12610 = 1;
            v12611 = v12614;
          }
        } else {
          v12610 = (v12608 * v12605 + v12609 * v12607) / v12612;
          v12611 = (v12610 * v12605 - v12608) / v12607;
        }
        v12611 = Math.max(0, Math.min(1, v12611));
        v12610 = Math.max(0, Math.min(1, v12610));
        const v12615 = v12602.multiplyScalar(v12610).add(p15619.start);
        const v12616 = v12603.multiplyScalar(v12611).add(p15620.start);
        return [v12615, v12616];
      }
    }
    THREE.Capsule = Capsule;
  }();
};